const attributes__english = [
  { title: "Description ", value: "description" },
  { title: "Colour", value: "color" },
  { title: "Composition", value: "composition" },
  { title: "Details", value: "details" },
  { title: "Delivery", value: "delivery" },
]
const attributes__spanish = [
  { title: "Descripción ", value: "description__spanish_" },
  { title: "Color", value: "color__spanish_" },
  { title: "Composición", value: "composition__spanish_" },
  { title: "Detalles", value: "details__spanish_" },
  { title: "Entrega", value: "delivery__spanish_" },
]

const getItemAttributesFromPrismicItem = (item, language) => {
  const attributes =
    language === "Spanish" ? attributes__spanish : attributes__english
  return attributes
    .map(attr => ({
      title: attr.title,
      value: item[attr.value],
    }))
    .filter(attr => {
      if (!!attr.value) {
        if (attr.value.hasOwnProperty("html")) {
          return !!attr.value.html
        } else {
          return true
        }
      }
      return false
    })
}

export default getItemAttributesFromPrismicItem